import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import Aos from "aos";
import 'aos/dist/aos.css';

const Container = styled.div`
   margin: 100px;
   @media (max-width: 768px) {
     margin:0;
     margin-bottom: 50px;
   }
`;

const PieriaBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
  overflow-x: hidden;
`;

const Title = styled.div`
  font-size: 40px;
  display: flex;
  color: #385963;
  font-weight: 600;
  margin-bottom: 10px;

  @media (max-width: 768px) { font-size: 25px; margin-bottom: 0; }
  @media (max-width: 480px) { font-size: 18px; margin-bottom: 0; }
`;

const Description = styled.div`
  font-size: 18px;
  color: #91abb3;
  margin: 50px;
  text-align: center;

  @media (max-width: 768px) { 
    font-size: 10px; margin: 10px 20px 50px; 
  }
`;

const StatisticsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 100px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    margin-bottom: 50px;
    flex-direction: column;
  }
`;

const Statistics = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 40px;

  @media (max-width: 768px) { margin: 15px 20px; }
  @media (max-width: 480px) { margin: 10px; }
`;

const Translations = styled.div`
  color: #385963;
  font-size: 30px;
  text-align: center;

  @media (max-width: 768px) { font-size: 25px; }
  @media (max-width: 480px) { font-size: 14px; }
`;

const Number = styled.div`
  color: #91abb3;
  font-size: 20px;
  margin-bottom: 5px;

  @media (max-width: 768px) { font-size: 16px; }
  @media (max-width: 480px) { font-size: 12px; }
`;

const DownloadPDF = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Message = styled.div`
   font-size: 16px;
   color: #385963;
   font-weight: 600;
   margin-bottom: 20px;
   text-align: center;

   @media (max-width: 768px) { font-size: 12px; }
   @media (max-width: 480px) { font-size: 8px; }
`;

const GeneralStatistics = () => {
  const { i18n, t } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");

  const emptyField = { en: '', gr: '' };
  const emptyStat = { label: { ...emptyField }, number: '' };

  const [pieriaInfo, setPieriaInfo] = useState({
    description1: { ...emptyField },
    description2: { ...emptyField },
    link: '',
    stat1: { ...emptyStat },
    stat2: { ...emptyStat },
    stat3: { ...emptyStat },
    stat4: { ...emptyStat },
  });

  useEffect(() => {
    Aos.init({ duration: 1000 });

    const fetchPieriaInfo = async () => {
      try {
        const res = await fetch(`${BASE_URL}PieriaInfo`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!res.ok) {
          console.warn('Failed to fetch Pieria info:', res.status);
          return;
        }
        const data = await res.json();
        if (data && data.length > 0) {
          const info = data[0];
          setPieriaInfo({
            description1: info.description1 || { ...emptyField },
            description2: info.description2 || { ...emptyField },
            link: info.link || '',
            stat1: info.stat1 || { ...emptyStat },
            stat2: info.stat2 || { ...emptyStat },
            stat3: info.stat3 || { ...emptyStat },
            stat4: info.stat4 || { ...emptyStat },
          });
        }
      } catch (err) {
        console.error('Fetch error:', err);
      }
    };

    fetchPieriaInfo();
  }, [BASE_URL, token]);

  const renderText = (field) => {
    if (!field) return t('noDataAvailable');
    return selectedLanguage === 'gr' ? field.gr || t('noDataAvailable') : field.en || t('noDataAvailable');
  };

  return (
    <Container>
      {/* Statistics */}
      {/* <StatisticsContainer>
        {['stat1', 'stat2', 'stat3', 'stat4'].map((statKey, idx) => (
          <Statistics key={statKey}>
            <Number data-aos="zoom-in">{pieriaInfo[statKey].number || '-'}</Number>
            <Translations data-aos="zoom-in-down">{renderText(pieriaInfo[statKey].label)}</Translations>
          </Statistics>
        ))}
      </StatisticsContainer> */}

      {/* Descriptions */}
      <PieriaBox>
        <Title data-aos="zoom-in">{t('aboutPieria')}</Title>

        <Description data-aos="zoom-in-down" style={{ whiteSpace: "pre-line" }}>
          {renderText(pieriaInfo.description1)}
        </Description>

        {/* <Description data-aos="zoom-in-down">
          {renderText(pieriaInfo.description2)}
        </Description> */}

      </PieriaBox>
    </Container>
  );
};

export default GeneralStatistics;
